
import {Enum} from '../../common/model/enum.model';

export class TipoAppartenenza extends Enum {

  constructor(protected value: string) {
    super(value);
  }

  public static values(): TipoAppartenenza[] {
    return [
      new TipoAppartenenza('SEDE'),
      new TipoAppartenenza('AFFERENZA_UO')
    ];
  }

}
